import type { AppSingleSelectOption } from '@libs/ui';

import type { SuggestionType } from './SuggestionTypeSelector.model';

export function getSelectedOptionForSuggestionType(
  allSuggestionTypes: AppSingleSelectOption<string>[],
  suggestionType: SuggestionType
): AppSingleSelectOption<string> | null {
  const result = allSuggestionTypes.find(
    (option: AppSingleSelectOption<string>) => option.id === suggestionType
  );

  return result || null;
}
